module.exports = __webpack_public_path__ + "img/content-cut.1e08bbfa.svg";